import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component.stocks';
import { PagerInfoComponent } from './uicomponents/pager-info.component';
import { PagerComponent } from './uicomponents/pager.component';
import { StockItemComponent } from './customcomponents/stock-item.component';
import { SafeHtmlPipe } from './pipes/SafeHtmlPipe'
//import { SimpleSelectComponent } from './uicomponents/simple-select.component';
// import ngx-translate and the http loader
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
@NgModule({
    imports: [BrowserModule, 
        // ngx-translate and the loader module
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    declarations: [AppComponent, PagerInfoComponent, PagerComponent, StockItemComponent, SafeHtmlPipe],
    bootstrap: [AppComponent]
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
    //return new TranslateHttpLoader(http, './assets/i18n/', '.json');
    return new TranslateHttpLoader(http);
}